import text from './text';

export const textarea = (value: any) => text(value);

export default textarea;
